/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { Account, Customer, CustomerAccount } from '@inyova/models';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as ProfileActions from '@profile/profile.actions';
import * as fromAppRoot from '@app/app.reducers';
import * as fromProfile from '@profile/profile.reducers';

import { PersonalDetails, PersonalDetailsCurrentScreen, ProfileTab } from '@shared/models/Profile';

@Component({
  selector: 'app-profile-personal-details',
  templateUrl: './profile-personal-details.component.html',
  styleUrls: ['./profile-personal-details.component.scss'],
  standalone: false
})
export class ProfilePersonalDetailsComponent implements OnDestroy {
  @Output() changeTab = new EventEmitter<ProfileTab>();
  customer: Customer;
  currentAccount: Account;
  has3AAccountMinProspect: boolean;
  hasAccountMinProspect: boolean;
  show2FADisableModal = false;
  currentScreen: PersonalDetailsCurrentScreen;
  showPass = false;
  twoFAEnabled = false;
  loading = false;

  personalDetails: Partial<PersonalDetails>;
  address = '';

  private readonly onDestroy$ = new Subject<void>();

  constructor(private store: Store) {
    this.store.pipe(select(fromProfile.selectPersonalDetailsCurrentScreen), takeUntil(this.onDestroy$)).subscribe((value) => {
      this.currentScreen = value;
    });
    this.store.pipe(select(fromProfile.selectShow2FADisableModal), takeUntil(this.onDestroy$)).subscribe((value) => {
      this.show2FADisableModal = value;
    });
    this.store.pipe(select(fromProfile.selectPersonalDetailsLoading), takeUntil(this.onDestroy$)).subscribe((value) => {
      this.loading = value;
    });
    this.store.pipe(select(fromAppRoot.selectCustomerAndCurrentAccount), takeUntil(this.onDestroy$)).subscribe((value) => {
      if (
        !value ||
        !value.currentAccountDetail ||
        (!value.currentAccountDetail.onboarding_step && !value.customer.has_crowd_investor_account) ||
        !value.customer ||
        !value.customer.accounts ||
        (!value.customer.accounts.length && !value.customer.has_crowd_investor_account)
      ) {
        return;
      }

      this.customer = value.customer;

      this.currentAccount = value.currentAccountDetail;
      this.twoFAEnabled = value.customer.otp_module === 'enabled';

      this.hasAccountMinProspect = value.customer.accounts.some((account) => account.step_status > 2);
      this.has3AAccountMinProspect = value.customer.accounts.some((account) => account.kind === '3a' && account.step_status > 2);
    });

    this.store.pipe(select(fromProfile.selectPersonalDetails), takeUntil(this.onDestroy$)).subscribe((value) => {
      this.personalDetails = value;
      if (!value.street || !value.city) {
        return;
      }
      this.address = `${value.street} ${value.number}, ${value.zip} ${value.city}`;
    });
  }

  close2FADisableModal(): void {
    this.store.dispatch(ProfileActions.updateShow2FADisableModal({ show: false }));
  }

  ngOnDestroy(): void {
    this.store.dispatch(ProfileActions.updatePersonalDetailsCurrentScreen({ screen: 'main' }));
    this.close2FADisableModal();
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  openTwoFA(): void {
    this.changeTab.emit('show2FA');
    this.store.dispatch(ProfileActions.update2FACurrentScreen({ screen: 'password' }));
    this.close2FADisableModal();
  }

  changeScreen(fieldName: PersonalDetailsCurrentScreen): void {
    this.store.dispatch(ProfileActions.updatePersonalDetailsCurrentScreen({ screen: fieldName }));
  }
}
